import { useQuery } from '@tanstack/react-query'
import { api } from '@/services/api'
import { SourceHealthResponse } from '@/types'

const SOURCE_HEALTH_QUERY_KEY = 'source-health'

export const useSourceHealth = () => {
  return useQuery<SourceHealthResponse>({
    queryKey: [SOURCE_HEALTH_QUERY_KEY],
    queryFn: async () => {
      const { data } = await api.get('/analytics/source-health')
      return data
    },
    refetchInterval: 5 * 60 * 1000,
  })
}
